<template>
	<el-menu :router="true" :default-active="active" class="el-menu-vertical-demo" @open="handleOpen"
		@close="handleClose" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
		<el-menu-item index="/admin/zonglan">
			<span slot="title">总览</span>
		</el-menu-item>
		<el-menu-item index="/admin/onething">
			<span slot="title">助残一件事</span>
		</el-menu-item>
		<el-menu-item v-if="iskangfu" index="/admin/kangfu">
			<span slot="title">康复救助全场景</span>
		</el-menu-item>
		<el-menu-item v-if="false" index="/admin/chizheng">
			<span slot="title">持证残疾人数据</span>
		</el-menu-item>
		<el-submenu index="1">
			<template slot="title">
				<span>残协管理</span>
			</template>
			<el-menu-item-group>
				<el-menu-item index="taskList">残协任务管理</el-menu-item>
				<el-menu-item index="resultList">任务结果</el-menu-item>
				<el-menu-item index="extensionList">就业状况</el-menu-item>
				<el-menu-item index="activityList">自发活动</el-menu-item>
				<el-menu-item index="/admin/canxieManage">残协管理</el-menu-item>
			</el-menu-item-group>
		</el-submenu>
		<el-submenu index="3">
			<template slot="title">
				<span>就业机构管理</span>
			</template>
			<el-menu-item-group>
				<el-menu-item index="companyList">机构列表</el-menu-item>
				<el-menu-item index="companyUserList">机构权限</el-menu-item>
				<el-menu-item index="policyList">政策管理</el-menu-item>
			</el-menu-item-group>
		</el-submenu>
		<el-submenu index="2" :disabled="info.allow_manage!=1">
			<template slot="title">
				<span>系统管理</span>
			</template>
			<el-menu-item-group>
				<el-menu-item index="/admin/setting">组织管理</el-menu-item>
				<el-menu-item index="/admin/settinguser">人员管理</el-menu-item>
			</el-menu-item-group>
		</el-submenu>

	</el-menu>
</template>

<script>
	export default {
		data() {
			return {
				active: "/admin/zonglan"
			}
		},
		computed: {
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			iskangfu() {
				let flag = false;
				this.info.role.map(p => {
					if (p == "儿童康复救助" || p == "all") {
						flag = true;
					}
				});
				return flag;
			}
		},
		created() {
			this.active = this.$route.path;
		},
		methods: {
			handleOpen() {

			},
			handleClose() {

			}
		}
	}
</script>

<style>
	.w130 {
		width: 100px;
	}

	.el-menu-vertical-demo {
		min-height: calc(100vh - 80px);
		width: 160px;
		overflow: hidden;
	}
</style>